import Grid from "@mui/material/Grid2";
import RefreshIcon from "@mui/icons-material/Refresh";
import { IconButton } from "@mui/material";
import MaterialBox from "../../components/MaterialBox";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialInput from "../../components/MaterialInput";

const DateFilter = ({ filter, dispatch, handlefilterChange, resetFilters }) => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ lg: 5, xs: 5, sm: 3 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            From Date <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          type="date"
          value={filter?.formDate}
          name="formDate"
          onChange={(e) => {
            dispatch({
              value: e?.target?.value,
              name: "formDate",
            });
            handlefilterChange(e, "formDate");
            dispatch({
              value: "",
              name: "endDate",
            });
          }}
          error={filter.formDateStatus === "error" ? true : false}
          success={filter.formDateStatus === "success" ? true : false}
        />
      </Grid>
      <Grid size={{ lg: 5, xs: 5, sm: 3 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            To Date <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          type="date"
          value={filter?.endDate}
          name="endDate"
          onChange={(e) => {
            handlefilterChange(e, "endDate");
            dispatch({
              value: e?.target?.value,
              name: "endDate",
            });
          }}
          disabled={filter?.formDate ? false : true}
          error={filter.endDateStatus === "error" ? true : false}
          success={filter.endDateStatus === "success" ? true : false}
          inputProps={{
            min: filter?.formDate,
          }}
        />
      </Grid>

      <Grid size={{ lg: 2, xs: 3, sm: 2 }}>
        <IconButton
          onClick={resetFilters}
          aria-label="Reset Filters"
          color="primary"
          sx={{ mt: 2 }}
        >
          <RefreshIcon fontSize="large" />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default DateFilter;
